/* eslint-disable react/no-array-index-key */
import React from 'react';

import { riskTexts } from './utils/riskTexts';

export type RiskLevel = 'low' | 'moderate' | 'high';
export type Category =
  | 'cavity_score'
  | 'plaque_buildup_score'
  | 'swollen_gums_score'
  | 'root_recession_score'
  | 'gaps_detected';

interface RiskTextDisplayProps {
  category: Category;
  riskLevel: RiskLevel;
}

const RiskTextDisplay: React.FC<RiskTextDisplayProps> = ({ category, riskLevel }) => {
  const mainTextArray = riskTexts[category].main.split('\n').filter(Boolean);
  const riskLevelArray = riskTexts[category].risk_level[riskLevel].split('\n').filter(Boolean);

  return (
    <div className="risk-text">
      {/* keep the very first paragraph joined with the row header */}
      {mainTextArray.length > 0 && (
        <div className="risk-intro pdf-avoid-break">
          <p className="pdf-keep" style={{ margin: 0 }}>
            {mainTextArray[0]}
          </p>
        </div>
      )}

      {mainTextArray.slice(1).map((line, i) => (
        <p className="pdf-keep" style={{ margin: 0 }} key={`main-${i}`}>
          {line}
        </p>
      ))}

      {riskLevelArray.map((line, i) => (
        <p className="pdf-keep" style={{ margin: 0 }} key={`risk-${i}`}>
          {line}
        </p>
      ))}
    </div>
  );
};

export default RiskTextDisplay;
